import { shallowRef, ref } from 'vue';

import type { OperatorFirstRideOfferInventoryOutputType } from '@/models/operatorFirstRideOfferInventory';
import { getOperatorFirstRideOfferInventory } from './getOperatorFirstRideOfferInventory';
import type { Offer } from '@/models/offerPromo';

export const meOperatorFirstRideOfferInventory = shallowRef<OperatorFirstRideOfferInventoryOutputType | null>(null);

export const fetchMeOperatorFirstRideOfferInventory = async (operatorId: string) => {
  meOperatorFirstRideOfferInventory.value = await getOperatorFirstRideOfferInventory(operatorId);
};

export const selectedOfferPromo = ref<Offer | null>(null);
export const isAppliedOfferedPromo = ref(false);
